
import Modal from "@/components/base/modal/Modal"
import LocationSearch2 from "@/components/search/LocationSearch2"
import SearchLocation from "@/components/search/SearchLocation"
import SearchCategory from "@/components/search/SearchCategory"
import { mapGetters } from "vuex"

export default {
    name: "SearchModal",
    components: { Modal, LocationSearch2, SearchLocation, SearchCategory },
    data() {
        return {
            searchInput: "",
            page: 0,
            cachedRoute: {},
            city: "",
        }
    },
    mounted() {
        if (this.location.slug) {
            this.page = 1
        }
    },
    computed: {
        ...mapGetters("search", ["searchModal", "location", "route", "type"]),
        dialog: {
            get() {
                return this.searchModal
            },
            set() {
                this.$store.commit("search/SET_SEARCH_MODAL", !this.dialog)
            },
        },
    },
    watch: {
        type(newVal) {
            if (newVal != this.cachedRoute.type) {
                this.cachedRoute = {}
            }
        },
        location(newVal) {
            if (!newVal.slug) {
                this.page = 0
            }
        },
    },
    methods: {
        searchNearby() {
            this.$refs.locationsearch.getCurrentLocation()
        },
        onLocationChange(route) {
            this.city = route.name
            this.cachedRoute = { ...route }
            this.page = 1
        },
        onCategoryChange(category) {
            delete this.cachedRoute.name
            // category here is e.g. "Ausbildung" or "Praktikum"
            this.cachedRoute.category = category
            let newRoute = this.route(this.cachedRoute)
            if (newRoute.name && newRoute.name.includes("messe")) {
                newRoute.query = {}
            }
            // deleting the search category like "Handwerk" or "Kunst & Unterhaltung"
            delete newRoute.query.category
            delete newRoute.query.tags
            this.$store.commit("search/SET_SEARCH_MODAL", false)
            this.$router.push(newRoute)
        },
    },
}
